<script>

  import ImagePicker from '../../Common/ImagePicker.svelte';
  import ColorPicker from '../../Common/ColorPicker.svelte';
  import { pickIcon, loadIcon } from '../../Common/MaterialIconPicker.svelte';
  import { External, M } from '../../external';

  export let styling, onChange = () => {
  };

  let pickCircleIcon = async () => {
    let icon = await pickIcon();
    if (icon) {
      styling.icon.value = icon;
      onChange();
    }
  };

  let onTypeChange = async () => {
    if (styling.type === 'icon') {
      if (styling.icon && styling.icon.value.length <= 20) {
        styling.icon.value = await loadIcon(styling.icon.value);
      }
    }
    onChange();
  }
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> brush </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.CIRCLE_IMAGE}</h4>

  <div class="popup-input-wrapper f-left mt-5 mb-5">
    <div class="info">
      <h5>{M.CIRCLE_PROFILE_IMAGE_TYPE}</h5>
    </div>
    <select class="page-select" bind:value={styling.type} on:change={onTypeChange}>
      <option value="image">{M.IMAGE}</option>
      <option value="icon">{M.ICON}</option>
      <option value="none">{External.WebPlatform.capitalizeFirstLetter(M.NONE?.toLowerCase())}</option>
    </select>
  </div>
  {#if styling.type === 'image'}
    <div class="popup-input-wrapper mb-0">
      <h5>{M.CIRCLE_IMAGE}</h5>
    </div>
    <ImagePicker
      onChange={onChange}
      bind:image={styling.image.name}
      bind:imageBase={styling.image.base} />
  {:else if styling.type === 'icon'}
    <div class="info">
      <h5>{M.OPTION_ICON}</h5>
      <span>{M.OPTION_ICON_DESC}</span>
    </div>
    <div class="iconpicker-value mt-5 mb-10" on:click={pickCircleIcon}>
      {#if styling.icon && styling.icon.value.length > 20}
        <span>{@html styling.icon.value}</span>
      {:else}
        <span class="material-icons-outlined">{styling.icon.value}</span>
      {/if}
    </div>
  {/if}
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>{M.CP_IMAGE_SIZE}</h5>
    </div>
    <select class="page-select" bind:value={styling.size} on:change={onChange}>
      <option value="small">{M.SMALL}</option>
      <option value="medium">{M.MEDIUM}</option>
      <option value="large">{M.LARGE}</option>
    </select>
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.coverBg.color}
      bind:colorClass={styling.coverBg.colorClass}
      onChange={onChange}
      label={M.CIRCLE_COVER_BG}
    />
  </div>

  {#if styling.type === 'icon'}
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker
        bind:color={styling.icon.fg.color}
        bind:colorClass={styling.icon.fg.colorClass}
        onChange={onChange}
        label={M.ICON_COLOR}
      />
    </div>

    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker
        bind:color={styling.icon.bg.color}
        bind:colorClass={styling.icon.bg.colorClass}
        onChange={onChange}
        label={M.ICON_BACKGROUND_COLOR}
      />
    </div>
  {/if}
</div>
